import { lazySubscribe, NotificationSubscription } from 'owa-notification';
import type SocialActivityNotificationPayload from 'owa-service/lib/contract/SocialActivityNotificationPayload';
import type PrimeNotificationPayload from 'owa-service/lib/contract/PrimeNotificationPayload';
import loadActivityFeed from '../utils/loadActivityFeed';
import { subscribeToSocialActivityNotification } from 'owa-app-notifications-core';

// This should always be in sync with the PrimeNotificationTypes
// being set in Prime every time the Activity Feed updates.
enum PrimeNotificationType {
    DeleteActivityFeedCollection = 'DeleteActivityFeedCollection',
    MarkActivityFeedItemsAsDismissed = 'MarkActivityFeedItemsAsDismissed',
    MarkActivityFeedItemsAsRead = 'MarkActivityFeedItemsAsRead',
    MarkActivityFeedItemsAsSeen = 'MarkActivityFeedItemsAsSeen',
    UpsertActivityFeedItem = 'UpsertActivityFeedItem',
}

// QueryNotificationType is returned by the reaction notification indicating any reaction modification for the user.
enum QueryNotificationType {
    RowAdded = 'RowAdded',
    RowDeleted = 'RowDeleted',
    QueryResultChanged = 'QueryResultChanged',
    Error = 'Error',
    RowModified = 'RowModified',
    SortDone = 'SortDone',
    RestrictDone = 'RestrictDone',
    SetColumnDone = 'SetColumnDone',
    Reload = 'Reload',
}

function onPrimeNotificationCallback(notification: PrimeNotificationPayload): void {
    switch (notification.PrimeNotificationType) {
        case PrimeNotificationType.DeleteActivityFeedCollection:
        case PrimeNotificationType.MarkActivityFeedItemsAsDismissed:
        case PrimeNotificationType.MarkActivityFeedItemsAsRead:
        case PrimeNotificationType.MarkActivityFeedItemsAsSeen:
        case PrimeNotificationType.UpsertActivityFeedItem:
            loadActivityFeed();
    }
}

function onReactionNotificationCallback(notification: SocialActivityNotificationPayload): void {
    switch (notification.EventType) {
        case QueryNotificationType.RowAdded:
        case QueryNotificationType.RowDeleted:
        case QueryNotificationType.RowModified:
            loadActivityFeed();
    }
}

export default function subscribeToPrimeNotification(isOpx: boolean = false): void {
    const subscription: NotificationSubscription = {
        subscriptionId: 'Prime Notification',
        requiresExplicitSubscribe: isOpx,
        subscriptionParameters: {},
    };
    lazySubscribe.importAndExecute(subscription, onPrimeNotificationCallback);
    // if isopx we should subscribe to reaction notification too to update the activity feed api.
    if (isOpx) {
        subscribeToSocialActivityNotification(onReactionNotificationCallback);
    }
}
